export default __webpack_public_path__ + "static/media/480_dummy2016-coach01-mobile-de.57928607.png";